const INVALID_FILENAME = /[\\/:*?"<>|]+/g;

export const pdfDownloadName = (invoice, url) => {
	const label =
		invoice?.ksefNumber ||
		invoice?.insideId ||
		invoice?.externalInvoiceNumber ||
		'';
	const fromUrl = fallbackNameFromUrl(url);
	const base = String(label || fromUrl || 'dokument')
		.replace(/\.pdf$/i, '')
		.replace(INVALID_FILENAME, '_')
		.replace(/\s+/g, ' ')
		.trim();

	return `${base || 'dokument'}.pdf`;
};

export const extractPdfBytes = (buffer) => {
	if (!buffer) return null;

	const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
	// A real PDF header is at the start. Allow a short non-PDF prefix (PHP notices)
	// and ignore anything past that so document text cannot be mistaken for a header.
	const limit = Math.min(bytes.length, 32768) - 4;

	for (let i = 0; i <= limit; i += 1) {
		if (
			bytes[i] === 0x25 &&
			bytes[i + 1] === 0x50 &&
			bytes[i + 2] === 0x44 &&
			bytes[i + 3] === 0x46
		) {
			return bytes.subarray(i);
		}
	}

	return null;
};

export const fetchPdfBytes = async (url) => {
	if (!url) return null;

	try {
		const response = await fetch(url, { method: 'GET' });
		if (!response.ok) return null;

		return extractPdfBytes(await response.arrayBuffer());
	} catch (error) {
		return null;
	}
};

export const savePdfFile = (bytes, filename) => {
	const name = `${String(filename || 'dokument').replace(/\.pdf$/i, '')}.pdf`;
	const blob = new Blob([bytes], { type: 'application/pdf' });
	const objectUrl = window.URL.createObjectURL(blob);
	const link = document.createElement('a');

	link.href = objectUrl;
	link.download = name;
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
};

export const downloadInvoicePdf = async (invoice) => {
	const urls = [invoice?.generatedPDF, invoice?.fakturomatPdfUrl].filter(
		(url, index, all) => url && all.indexOf(url) === index
	);

	for (const url of urls) {
		const pdf = await fetchPdfBytes(url);
		if (!pdf) continue;

		savePdfFile(pdf, pdfDownloadName(invoice, url));
		return true;
	}

	return false;
};

const fallbackNameFromUrl = (url) => {
	if (!url) return '';

	const segment =
		String(url).split('?')[0].split('#')[0].split('/').filter(Boolean).pop() ||
		'';

	try {
		return decodeURIComponent(segment);
	} catch (error) {
		return segment;
	}
};
